/* eslint-disable @typescript-eslint/naming-convention */
export const LOADER_CONST = {
  DISABLE_LOADER: 'disableLoader'
};

